import "./styling/HomePage.css"
import CenteredMessage from "../Components/CenteredMessage/CenteredMessage";
import ImageCarousel from "../Components/ImageCarousel/ImageCarousel";
import CarouselFactory from "../Components/CarouselFactory/CarouselFactory";
import Footer from "../Components/Footer/Footer";

import { ModalMessage } from "../Components/ModalMessage/ModalMessage";
import { FaSearch, FaUser } from "react-icons/fa";
import { useState, useEffect } from "react";
import { usePlaylists } from "../hooks/usePlaylist";
import { useBanners } from "../hooks/useBanners";
import { useNavigate } from "react-router-dom"
import { LoadingMessage } from "../Components/ModalMessage/LoadingMessage";

export const HomePage = () => {
  const { playlists, loading: playlist_loading, error: playlist_error } = usePlaylists();
  const { banners, loading: banners_loading, error: banners_error, fetchBanners } = useBanners();
  const [showSearch, setShowSearch] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    fetchBanners();
  }, []);

  const handleProfileClick = () => {
    navigate('/profile');
  };

  const handleSearchClick = () => {
    setShowSearch(!showSearch);
  };

  const normalize = (text) =>
    (text || '')
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, '');

  const filterContent = (playlist) => {
    const normalizedSearch = normalize(searchText);
    const titleMatches = normalize(playlist.sectionTitle).includes(normalizedSearch);
    const keywordMatches =
      Array.isArray(playlist.keywords) &&
      playlist.keywords.some((keyword) => normalize(keyword).includes(normalizedSearch));

    const sectionMatches = titleMatches || keywordMatches;

    const contents = playlist.chapter.map(ch => ch.content).filter(Boolean);
    const filteredContents = contents.filter(content =>
      normalize(content.title).includes(normalizedSearch) ||
      normalize(content.subtitle || '').includes(normalizedSearch) ||
      normalize(content.description || '').includes(normalizedSearch)
    );

    if (sectionMatches || filteredContents.length > 0) {
      return {
        ...playlist,
        contents: sectionMatches ? contents : filteredContents
      };
    }

    return null;
  };

  if (playlist_loading || banners_loading) {
    return <LoadingMessage />;
  }

  if (playlist_error && banners_error) {
    return (
      <CenteredMessage
        title="Erro ao carregar conteúdo"
        message="Não foi possível carregar o conteúdo. Por favor, tente novamente mais tarde."
        buttonText="Tentar novamente"
        buttonAction={() => {
          window.location.reload();
        }}
      />
    );
  }

  const hasNoContent = (!playlists || playlists.length === 0) && (!banners || banners.length === 0);
  if (hasNoContent) {
    return (
      <CenteredMessage
        title="Nenhum conteúdo disponível"
        message="Não há conteúdo disponível no momento. Por favor, volte mais tarde."
        buttonText="Tentar novamente"
        buttonAction={() => {
          window.location.reload();
        }}
      />
    );
  }

  const filteredPlaylists = playlists
    .map(filterContent)
    .filter(Boolean);

  const hasNoSearchResults = searchText && filteredPlaylists.length === 0;

  return (
    <div className="home-page-container">
      <div className="top-buttons-container">
        <img src="/imgs/reino_header_logo.svg" alt="Logo" className="header-logo" />
        <div className="buttons-wrapper">
          <FaSearch className="search-button" onClick={handleSearchClick}></FaSearch>
          {showSearch && (
            <input
              className="search-input"
              type="text"
              placeholder="Pesquisar conteúdo"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
            />
          )}

          <FaUser className="profile-button" onClick={handleProfileClick}></FaUser>
        </div>
      </div>

      {!banners_error && banners && banners.length > 0 && (
        <div className="img-carousel">
          <ImageCarousel banners={banners} />
        </div>
      )}

      {hasNoSearchResults ? (
        <CenteredMessage
          title="Nenhum resultado encontrado"
          message={`Não encontramos nenhum conteúdo para "${searchText}"`}
        />
      ) : (
        <div className="playlists">
          {filteredPlaylists.map((playlist) => (
            <CarouselFactory
              key={playlist.sectionId}
              section={{
                title: playlist.sectionTitle,
                contents: playlist.contents,
                exhibitionType: playlist.sectionExhibitionType || 'landscape'
              }}
            />
          ))}
        </div>
      )}

      <Footer />
    </div>
  );
};